<template>
  <div class="ebook-benefits-section">
    <div class="benefits-container">
      <!-- Columna izquierda: Contenido -->
      <div class="benefits-content">
        <div class="content-header">
          <div class="section-badge">
            <div class="badge-line"></div>
            <span class="badge-text">BENEFICIOS</span>
          </div>
          <h2 class="main-title">Beneficios inmediatos que obtendrás</h2>
        </div>

        <p class="intro-text">
          Lo esencial para pasar de hojas sueltas a una operación de mantenimiento
          <strong>trazable, auditable y predecible.</strong>
        </p>

        <ul class="benefits-list">
          <li class="benefit-item">
            <div class="check-icon">
              <span class="material-symbols-outlined"> check </span>
            </div>
            <span>Elimina duplicados y versiones rotas en Excel.</span>
          </li>
          <li class="benefit-item">
            <div class="check-icon">
              <span class="material-symbols-outlined"> check </span>
            </div>
            <span>Activa órdenes de trabajo, alertas y aprobaciones en un solo lugar.</span>
          </li>
          <li class="benefit-item">
            <div class="check-icon">
              <span class="material-symbols-outlined"> check </span>
            </div>
            <span>Centraliza historial y evidencias para auditorías sin fricción.</span>
          </li>
          <li class="benefit-item">
            <div class="check-icon">
              <span class="material-symbols-outlined"> check </span>
            </div>
            <span>Mejora KPIs: MTTR↓, MTBF ↑, % cumplimiento de OT ↑.</span>
          </li>
          <li class="benefit-item">
            <div class="check-icon">
              <span class="material-symbols-outlined"> check </span>
            </div>
            <span>Calcula el ROI de digitalizar mantenimiento (plantillas incluidas).</span>
          </li>
          <li class="benefit-item">
            <div class="check-icon">
              <span class="material-symbols-outlined"> check </span>
            </div>
            <span>Estandariza checklists por equipo, sede y criticidad del activo.</span>
          </li>
        </ul>

        <button class="download-cta" @click="scrollToForm">
          <span>Descargar ebook</span>
          <svg class="cta-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M7 17L17 7M17 7H7M17 7V17"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <!-- Columna derecha: Imagen del ebook -->
      <div class="benefits-image-column">
        <div class="ebook-stack">
          <img
            src="@/assets/images/benefits.png"
            alt="Ebook: Del Excel al mantenimiento inteligente"
            class="benefits-image"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const scrollToForm = () => {
  const formElement = document.querySelector('.ebook-form-section')
  if (formElement) {
    formElement.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>

<style scoped>
.ebook-benefits-section {
  padding: 80px 20px;
  background: #129bef;
  min-height: 60vh;
}

.benefits-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 60px;
  align-items: center;
}

.benefits-content {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.content-header {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.section-badge {
  display: flex;
  align-items: center;
  gap: 12px;
}

.badge-line {
  width: 40px;
  height: 2px;
  background: rgba(255, 255, 255, 0.6);
}

.badge-text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.main-title {
  font-size: clamp(2rem, 4vw, 2.5rem);
  font-weight: 600;
  color: white;
  line-height: 1.2;
  margin: 0;
}

.intro-text {
  font-size: 18px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

.intro-text strong {
  color: white;
  font-weight: 600;
}

.benefits-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.check-icon {
  width: 24px;
  height: 24px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.check-icon .material-symbols-outlined {
  color: #129bef;
  font-size: 18px;
}

.benefit-item span {
  font-size: 16px;
  line-height: 1.5;
  color: white;
}

.download-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: white;
  color: #129bef;
  border: none;
  padding: 18px 36px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: fit-content;
  margin-top: 20px;
}

.download-cta:hover {
  background: rgba(255, 255, 255, 0.9);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 255, 255, 0.3);
}

.cta-arrow {
  transition: transform 0.3s ease;
}

.download-cta:hover .cta-arrow {
  transform: translate(2px, -2px);
}

.benefits-image-column {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ebook-stack {
  position: relative;
  width: 100%;
}

.benefits-image {
  max-width: 600px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.2));
}

@media (max-width: 1024px) {
  .benefits-container {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }

  .benefits-image-column {
    order: -1;
  }

  .ebook-stack {
    max-width: 250px;
  }
}

@media (max-width: 768px) {
  .ebook-benefits-section {
    padding: 60px 15px;
  }

  .benefits-container {
    gap: 30px;
  }

  .main-title {
    font-size: 1.8rem;
  }

  .intro-text {
    font-size: 16px;
  }

  .benefit-item {
    text-align: left;
  }

  .download-cta {
    width: 100%;
    padding: 16px 32px;
    font-size: 16px;
  }

  .benefits-image {
    max-width: 250px;
  }
}

@media (max-width: 480px) {
  .ebook-benefits-section {
    padding: 40px 10px;
  }

  .benefits-list {
    gap: 16px;
  }

  .benefit-item span {
    font-size: 15px;
  }


}
</style>
